import _ from 'lodash'
import fp from 'lodash/fp'
import { runInAction } from 'mobx'
import { parseSupportedLanguageFromLocation } from 'common/src/vtj/browser/url-utils'
import { createAction, withStore } from 'common/src/vtj/mobx/action-creator'
import supportedPageLanguages from 'todistukset-ui/src/vtj/page-lang-options'
import publicSettings from 'todistukset-ui/src/vtj/public-settings'
import { queuePriorityDialogGlobalError } from 'todistukset-ui/src/vtj/stores/actions/dialog-actions'
import { isInsideBrowser } from 'common/src/vtj/browser/browser-util'
import i18next from 'todistukset-ui/src/vtj/i18next'

const parseLanguageFromLocation = parseSupportedLanguageFromLocation(
  supportedPageLanguages()
)

const verifyPageLanguage = (newLang) =>
  _.includes(supportedPageLanguages(), newLang)
    ? newLang
    : _.first(supportedPageLanguages())

export const selectUiLanguage = (newLang, i18next) =>
  createAction(({ common }) => {
    common.lang = verifyPageLanguage(newLang)
    if (i18next) {
      i18next.changeLanguage(newLang)
    }
  })

export const languageWhenBackButtonPressed = selectUiLanguage

export const handleError = (options) => {
  const { error, storePath, errorValue } = options
  const settings = publicSettings.getPublicSettings()
  if (!settings.get('production')) {
    console.error(error)
  }
  withStore((store) =>
    runInAction(() => {
      if (fp.has(storePath, store)) {
        _.set(store, storePath, errorValue)
      }
      const status = error?.status ?? error?.response?.status ?? -1
      queuePriorityDialogGlobalError({ status })
    })
  )
}

export const setOrderRequestStatus = ({ order, requestStatus }) => {
  runInAction(() => {
    order.requestStatus = requestStatus
  })
}

if (isInsideBrowser()) {
  window.addEventListener('popstate', (e) =>
    languageWhenBackButtonPressed(
      parseLanguageFromLocation(e.currentTarget.window.location),
      i18next
    )
  )
}

export const setPreviousAddressDialogDismissed = (value) =>
  createAction(({ common }) => {
    common.previousAddressDialogDismissed = value
  })
